"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _createRecord = require("@/api/shoppingGift/createRecord");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Account',
  data: function data() {
    return {
      queryData: {
        goodsId: '',
        memberId: '',
        nickname: '',
        status: '',
        phone: null,
        id: null,
        pageNo: 1,
        limit: 10
      },
      checkList: ['商品图片', '会员', '商品名称', '商品ID', '单个礼金金额（元）', '发放个数', '已领取使用（个）', '已核销金额（元）', '淘礼金状态', '创建时间', '领取时间', '使用时间'],
      tableData: [],
      total: 0,
      dialogVisible: false,
      titleTxt: '',
      ruleForm: {
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 5,
          message: '长度在 3 到 5 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.queryData = JSON.parse(localStorage.getItem('tlj_createRecord')) || this.queryData;
    this.getTljCreateRecord();
    // this.checkList = localStorage.getItem('Selected_createRecord')
  },
  methods: {
    // 存储列
    onCheckBox: function onCheckBox() {
      localStorage.setItem('Selected_createRecord', JSON.stringify(this.checkList));
    },
    onInquire: function onInquire() {
      this.queryData.pageNo = 1;
      this.queryData.size = 10;
      this.getTljCreateRecord();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        goodsId: '',
        memberId: '',
        nickname: '',
        status: '',
        phone: null,
        id: null,
        pageNo: 1,
        limit: 10
      };
      localStorage.setItem('tlj_createRecord', JSON.stringify(this.queryData));
      this.getTljCreateRecord();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.limit = val;
      this.getTljCreateRecord();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.pageNo = val;
      this.getTljCreateRecord();
    },
    onRecharge: function onRecharge() {
      this.titleTxt = '淘礼金充值';
      this.dialogVisible = true;
    },
    onDeduction: function onDeduction() {
      this.titleTxt = '淘礼金扣款';
      this.dialogVisible = true;
    },
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    onClose: function onClose() {
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getTljCreateRecord: function () {
      var _getTljCreateRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _createRecord.getTljCreateRecord)(params);
            case 1:
              res = _context.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getTljCreateRecord() {
        return _getTljCreateRecord2.apply(this, arguments);
      }
      return getTljCreateRecord;
    }(),
    // 淘礼金详情
    handleClick: function handleClick(data) {
      console.log('前往详情', data);
      localStorage.setItem('tlj_createRecord', JSON.stringify(this.queryData));
      this.$router.push({
        path: '/shoppingGift/recordDetails',
        query: {
          data: JSON.stringify(data)
        }
      });
    }
  }
};